import { render, staticRenderFns } from "./DeviceMange.vue?vue&type=template&id=47c2730c&scoped=true"
import script from "./DeviceMange.vue?vue&type=script&lang=js"
export * from "./DeviceMange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2730c",
  null
  
)

export default component.exports